import React, { PureComponent } from 'react'
import { Button } from 'react-bootstrap'
import ConfirmationModal from '../confirmation_modal'
import * as Sentry from '@sentry/react'

/**
 * specialized ConfirmationModal component
 */
class RestartConfirmationModal extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      error_code: null,
    }
  }

  handleSaveChanges = () => {}

  setSelected = (error) => {
    this.setState({
      error_code: error.error_code_id,
    })
  }

  render() {
    const { props, state } = this
    const { errors } = props

    const missedErrorDescriptions = props.errors
      .filter((i) => i.error_code_description === '')
      .map((i) => ({
        error_code_id: i.error_code_id,
        error_code_name: i.error_code_name,
        language_code: i.language_code,
      }))

    if (missedErrorDescriptions.length) {
      Sentry.captureException(`Missed error descriptions:${JSON.stringify(missedErrorDescriptions)}`)
    }

    return (
      <ConfirmationModal
        style={{ divWidth: 800 }}
        error_code={state.error_code}
        id={props.id}
        isModalConfirmationOpen={props.isModalConfirmationOpen}
        title='Confirm'
        close={props.close}
        cancel={props.cancel}
      >
        <div className='form-group'>
          <label style={{ paddingTop: 50 }} className='control-label'>
            Please select MOST relevant message to user, and add notes for `&quot;Internal Use Only`&quot; to the box
            below.
          </label>
          <div style={{ display: 'flex', flexDirection: 'row', paddingTop: 10 }}>
            <div
              style={{
                overflowX: 'hidden',
                overflowY: 'scroll',
                display: 'flex',
                flexDirection: 'column',
                height: 210,
                width: 700,
              }}
            >
              <hr />
              <div style={{ width: 700 }}>
                {errors &&
                  errors
                    .filter((error) => {
                      return error.category === 'document'
                    })
                    .map((error, index) => (
                      <Button
                        key={index}
                        style={{ textAlign: 'left', width: 700, marginBottom: '2px' }}
                        variant={state.error_code === error.error_code_id ? 'danger' : 'default'}
                        onClick={() => this.setSelected(error)}
                      >
                        {error.error_code_description || error.error_code_name}
                      </Button>
                    ))}
              </div>
            </div>
          </div>
        </div>
      </ConfirmationModal>
    )
  }
}

export default RestartConfirmationModal
